/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from './axios';
import {
  AGENCYAPI,
  BASEURL,
  APPLICATIONS,
  SIGNIN,
  SIGNUP,
  CONSTANTS,
  APPLICATION,
  SUBMIT_APPLICATION,
  QUOTE_LIST,
  CURRENT_APPLICATION,
  FORGOTPASSWORD,
  VERIFYUSEREMAIL,
  SETUSERPASSWORD,
  COPYAPPLICATION,
  SCHEDULEREMAINDER,
  VERIFYEMAILOTP,
  RESENDOTP,
  PRE_BIND_APPLICATION,
  GET_APP_DATA,
  SUBMIT_FINAL_APPLICATION,
  PAYMENT_DETAILS,
  MAKE_PAYMENT,
  ADMIN_APPLICATIONS,
  UPLOAD_URL,
  UPLOAD_POLICY,
  ACTIVE_SCREEN,
  GET_CURRENT_APP_DATA,
  BIND_APPLICATION
} from '../utils/constants';
import {
  AGENCYI,
  SignInCredentials,
  SignInResponse,
  SignUpRequest,
  loginError,
  PROPPERTYI,
  SUBMITAPPLICATIONI,
  QUOTES,
  ApplicationResponse,
  APPLICATIONI,
  SINGLEAPPLICATION,
  RegisterUserResponseI,
  PREBINDAPPLICATION,
  PropertyData,
  BINDAPPLICATION
} from '../utils/typeI';
import { useMutation } from '@tanstack/react-query';

const apiKey = import.meta.env.VITE_API_KEY;

export const fetchAgencies = async (searchBy: string): Promise<AGENCYI> => {
  try {
    const response = await axiosInstance
      .get(BASEURL + AGENCYAPI + `&searchBy=${searchBy}`, {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json'
        }
      })
      .then((res) => res.data);
    return response.result;
  } catch (err) {
    throw new Error("'Network response was not ok'");
  }
};

export const forgotPassword = async (email: { email: string }): Promise<any> => {
  const response = await axiosInstance
    .post(BASEURL + FORGOTPASSWORD, email, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json'
      }
    })
    .then((res) => res.data);
  return response;
};

export const verifyEmail = async (uuid: { uuid: string }): Promise<any> => {
  const response = await axiosInstance
    .post(BASEURL + VERIFYUSEREMAIL, uuid, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json'
      }
    })
    .then((res) => res.data);
  return response;
};
export const uploadUrl = async ({
  filePath,
  bucket
}: {
  filePath: string;
  bucket: string;
}): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + UPLOAD_URL,
      { filePath, bucket },
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }
    )
    .then((res) => res.data);
  return response;
};
export const uploadPolicy = async ({
  applicationId,
  quoteId,
  policyUrls,
  user
}: {
  applicationId: string;
  quoteId: string;
  policyUrls: string[];
  user: any;
}): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + UPLOAD_POLICY,
      { applicationId, quoteId, policyUrls },
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user?.token}`
        }
      }
    )
    .then((res) => res.data);
  return response;
};

export const verifyEmailOtp = async (params: { otp: string; token: string }): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + VERIFYEMAILOTP,
      { otp: parseInt(params.otp) },
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${params.token}`
        }
      }
    )
    .then((res) => res.data);
  return response;
};

export const resendEmailOtp = async (params: { token: string }): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + RESENDOTP,
      {},
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${params.token}`
        }
      }
    )
    .then((res) => res.data);
  return response;
};

export const scheduleRemainder = async (param: {
  applicationId: string;
  reminderDate: string;
  token: string;
}): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + SCHEDULEREMAINDER,
      { applicationId: param.applicationId, reminderDate: param.reminderDate },
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${param.token}`
        }
      }
    )
    .then((res) => res.data);
  return response;
};

export const setUserPassword = async (param: {
  password: string;
  confirmPassword: string;
  token: string;
}): Promise<any> => {
  const response = await axiosInstance
    .post(
      BASEURL + SETUSERPASSWORD,
      { password: param.password, confirmPassword: param.confirmPassword },
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${param.token}`
        }
      }
    )
    .then((res) => res.data);
  return response;
};

export const applicationList = async (
  token: string | undefined,
  offset: number,
  type: string
): Promise<APPLICATIONI[]> => {
  const response = await axiosInstance
    .get(BASEURL + APPLICATIONS + `?limit=10&offset=${offset}&type=${type}`, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response.result;
};

export const adminApplicationList = async (
  token: string | undefined,
  offset: number,
  type: string,
  limit: number,
  search: string
): Promise<any> => {
  const response = await axiosInstance
    .get(
      BASEURL +
        ADMIN_APPLICATIONS +
        `?limit=${limit}&offset=${offset}&type=${type}&search=${search}`,
      {
        headers: {
          'x-api-key': apiKey,
          portalType: 'FLOOD_AGENT_PORTAL',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((res) => res.data);
  return response.result;
};
export const getPaymentDetails = async (
  token: string | undefined,
  applicationId: string,
  quoteId: string
): Promise<any> => {
  const response = await axiosInstance
    .get(BASEURL + PAYMENT_DETAILS + `?applicationId=${applicationId}&quoteId=${quoteId}`, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response.result;
};

export const copyApplicationLink = async (
  applicationId: string,
  token: string | undefined
): Promise<{ statusCode: number; message: string; result: string }> => {
  const response = await axiosInstance
    .get(BASEURL + COPYAPPLICATION + `?applicationId=${applicationId}`, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response;
};

export const quoteList = async (token: string, applicationId: string | null): Promise<QUOTES[]> => {
  const response = await axiosInstance
    .get(`${BASEURL}${QUOTE_LIST}?applicationId=${applicationId}`, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  // let sortedResult: QUOTES[] = response.result.sort(
  //   (a: QUOTES, b: QUOTES) =>
  //     (a.netPremium !== null ? Number(a.netPremium) : Infinity) -
  //     (b.netPremium !== null ? Number(b.netPremium) : Infinity)
  // );
  // sortedResult = sortedResult.sort((a: QUOTES, b: QUOTES) =>
  //   a.carrierCompany.name === "NFIP"
  //     ? -1
  //     : b.carrierCompany.name === "NFIP"
  //     ? 1
  //     : 0
  // );
  return response.result;
};

export const getInstance = async (token: string | undefined): Promise<PropertyData[]> => {
  const response = await axiosInstance
    .get<{ result: any }>(BASEURL + CONSTANTS, {
      headers: {
        'x-api-key': apiKey,
        portalType: 'FLOOD_AGENT_PORTAL',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response.result;
};
export const getCurrentApplication = async (
  token: string | undefined,
  applicationId: string | null
): Promise<SINGLEAPPLICATION> => {
  const response = await axiosInstance
    .get<ApplicationResponse>(`${BASEURL}${CURRENT_APPLICATION}?applicationId=${applicationId}`, {
      headers: {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        portalType: 'FLOOD_AGENT_PORTAL',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response.result;
};
export const getAppData = async (
  token: string | undefined,
  applicationId: string | null,
  quoteId: string | null
) => {
  const response = await axiosInstance
    .get<any>(`${BASEURL}${GET_APP_DATA}?applicationId=${applicationId}&quoteId=${quoteId}`, {
      headers: {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        portalType: 'FLOOD_AGENT_PORTAL',
        Authorization: `Bearer ${token}`
      }
    })
    .then((res) => res.data);
  return response.result;
};
export const getCurrentAppData = async (
  token: string | undefined,
  applicationId: string | null,
  quoteId: string | null
) => {
  const response = await axiosInstance
    .get<ApplicationResponse>(
      `${BASEURL}${GET_CURRENT_APP_DATA}?applicationId=${applicationId}&quoteId=${quoteId}`,
      {
        headers: {
          'x-api-key': apiKey,
          'Content-Type': 'application/json',
          portalType: 'FLOOD_AGENT_PORTAL',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((res) => res.data);
  return response.result;
};
export const getActiveScreen = async (
  token: string | undefined,
  applicationId: string | null,
  quoteId: string | null
) => {
  const response = await axiosInstance
    .get<ApplicationResponse>(
      `${BASEURL}${ACTIVE_SCREEN}?applicationId=${applicationId}&quoteId=${quoteId}`,
      {
        headers: {
          'x-api-key': apiKey,
          'Content-Type': 'application/json',
          portalType: 'FLOOD_AGENT_PORTAL',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((res) => res.data);
  return response.result;
};

export const signIn = async (credentials: SignInCredentials): Promise<SignInResponse> => {
  const response = await axiosInstance.post<SignInResponse>(SIGNIN, credentials, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

export const signUp = async (signUpRequest: SignUpRequest): Promise<RegisterUserResponseI> => {
  const response = await axiosInstance.post<RegisterUserResponseI>(SIGNUP, signUpRequest, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

export const initiateApplication = async (properties: PROPPERTYI): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.post<any>(APPLICATION, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};
export const submitApplication = async (properties: SUBMITAPPLICATIONI): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.post<any>(SUBMIT_APPLICATION, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};
export const makePayment = async (properties: any): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.post<any>(MAKE_PAYMENT, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};
export const preBindApplication = async (properties: PREBINDAPPLICATION): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.post<any>(PRE_BIND_APPLICATION, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};
export const bindApplication = async (properties: PREBINDAPPLICATION): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.put<any>(BIND_APPLICATION, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};

export const submitFinalApplication = async (properties: BINDAPPLICATION): Promise<any> => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  const response = await axiosInstance.post<any>(SUBMIT_FINAL_APPLICATION, properties, {
    headers: {
      'x-api-key': apiKey,
      portalType: 'FLOOD_AGENT_PORTAL',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    }
  });
  return response.data;
};

export const useSignIn = () => {
  return useMutation<SignInResponse, loginError, SignInCredentials>({
    mutationFn: (params: SignInCredentials) => signIn(params)
  });
};

export const useSignUp = () => {
  return useMutation<RegisterUserResponseI, Error, SignUpRequest>({
    mutationFn: (params: SignUpRequest) => signUp(params)
  });
};

export const useApplication = () => {
  return useMutation<any, Error, PROPPERTYI>({
    mutationFn: (params: PROPPERTYI) => initiateApplication(params)
  });
};
export const useSubmitApplication = () => {
  return useMutation<any, Error, SUBMITAPPLICATIONI>({
    mutationFn: (params: SUBMITAPPLICATIONI) => submitApplication(params)
  });
};
export const useMakePayment = () => {
  return useMutation<any, Error, any>({
    mutationFn: (params: any) => makePayment(params)
  });
};
export const usePreBindApplication = () => {
  return useMutation<any, Error, PREBINDAPPLICATION>({
    mutationFn: (params: PREBINDAPPLICATION) => preBindApplication(params)
  });
};

export const useSubmitFinalApplication = () => {
  return useMutation<any, Error, BINDAPPLICATION>({
    mutationFn: (params: BINDAPPLICATION) => submitFinalApplication(params)
  });
};
export const useBindApplication = () => {
  return useMutation<any, Error, BINDAPPLICATION>({
    mutationFn: (params: BINDAPPLICATION) => bindApplication(params)
  });
};

export const useForgotPassword = () => {
  return useMutation<{ email: string }, any, any>({
    mutationFn: (param: { email: string }) => forgotPassword(param)
  });
};

export const useVerifyEmail = () => {
  return useMutation<{ uuid: string }, any, any>({
    mutationFn: (param: { uuid: string }) => verifyEmail(param)
  });
};
export const useUploadUrl = () => {
  return useMutation<{ result: string }, any, any>({
    mutationFn: (param: { filePath: string; bucket: string }) => uploadUrl(param)
  });
};

export const useUploadPolicy = () => {
  return useMutation<
    { applicationId: string; quoteId: string; policyUrls: string[]; user: any },
    any,
    any
  >({
    mutationFn: (param: {
      applicationId: string;
      quoteId: string;
      policyUrls: string[];
      user: any;
    }) => uploadPolicy(param)
  });
};

export const useScheduleRemainder = () => {
  return useMutation<{ applicationId: string; reminderDate: string }, any, any>({
    mutationFn: (param: { applicationId: string; reminderDate: string; token: string }) =>
      scheduleRemainder(param)
  });
};

export const useSetPassword = () => {
  return useMutation<
    {
      password: string;
      confirmPassword: string;
    },
    Error,
    any
  >({
    mutationFn: (param: { password: string; confirmPassword: string; token: string }) =>
      setUserPassword(param)
  });
};
